import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.3.8_react-dom@19.0.3_react@19.0.3__react@19.0.3/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["MyNav"] */ "/app/src/components/headers/header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/app/src/components/ui/separator.tsx");
